import { List, Button } from "antd";
import React from "react";

function Item({ id, onClick, status, title, createdAt, note }) {
  return (
    <List.Item
      key={`contact-premium-${id}`}
      actions={[<Button type="primary" icon="edit" onClick={onClick} />]}
    >
      <List.Item.Meta
        avatar={
          <div
            title={status}
            style={{
              width: "25px",
              height: "25px",
              fontSize: "22px",
              color: "#000",
            }}
          >
            {status == "sold" ? "💲" : "❌"}
          </div>
        }
        title={title}
        description={
          <div>
            <p>{createdAt}</p>
            <p>{note}</p>
          </div>
        }
      />
    </List.Item>
  );
}

export default Item;
